// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { Chip, MenuItem } from '@mui/material';
import {
    TextSnippet as TextSnippetIcon,
    Comment as CommentIcon
} from '@mui/icons-material';
import i18n from '../../../i18n';
import DocumentsDialog from '../../dialogs/DocumentsDialog';
import CommentsDialog from '../../dialogs/CommentsDialog';
import Iconify from '../../../components/iconify';
import React from 'react';
import ConfirmDialog from '../../dialogs/ConfirmDialog';
import { appealStatuses, instanceStates, terminalFlags } from '../statuses';
import { getModifiedBy, getUuidTransactionByKind } from '../../../utils/cells';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
export default class AppealsPage extends GridPageAbstract {
    appealsDocuments = [];
    appealsComments = [];

    constructor(props) {
        super(props);

        this.Name = 'publicAppeals';
        this.Server = this.props.context.getState().server.publicAppeals;
        this.MenuDisplayType = 'menu';
        this.searchFields = [
            'reason',
            'description',
            'payment.uuid',
            'payout.uuid',
            'p2p.uuid'
        ];
        this.showTotalRow = false;
        this.exportButton = true;

        this.hasCustomLogicOnMount = true;

        const defaultHead = [
            {
                id: 'reason',
                label: 'reason',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                displayAdd: true,
                disableEditor: true
            },
            {
                id: 'description',
                label: 'description',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                displayAdd: true,
                disableEditor: true
            },
            {
                id: 'correctValue',
                label: 'correctValue',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'correctStatus',
                label: 'correctStatus',
                alignRight: false,
                cell: 'State',
                items: Object.keys(instanceStates),
                displayGrid: true
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'State',
                // pending,
                // approved,
                // rejected,
                // executed
                items: Object.keys(appealStatuses),
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'kind',
                label: 'kind',
                alignRight: false,
                cell: 'Items',
                items: Object.keys(terminalFlags),
                extraRender: (value, row) =>
                    getUuidTransactionByKind(value, row),
                enableCopyExtraRender: true,
                displayGrid: true
            },
            // need to add amount
            {
                id: 'paymentUuid',
                label: 'paymentUuid',
                alignRight: false,
                cell: 'ServerSearch',
                searchFields: ['uuid'],
                outputField: 'uuid',
                searchController: 'paymentInstances',
                object: 'payment',
                show: 'uuid',
                displayGrid: false,
                showIfDialog: (data) => data.kind === 'payment'
            },
            {
                id: 'payoutUuid',
                label: 'payoutUuid',
                alignRight: false,
                cell: 'ServerSearch',
                searchFields: ['uuid'],
                outputField: 'uuid',
                searchController: 'payoutInstances',
                object: 'payout',
                show: 'uuid',
                displayGrid: false,
                showIfDialog: (data) => data.kind === 'payout'
            },
            {
                id: 'p2pUuid',
                label: 'p2pUuid',
                alignRight: false,
                cell: 'ServerSearch',
                searchFields: ['uuid'],
                outputField: 'uuid',
                searchController: 'p2pInstances',
                object: 'p2p',
                show: 'uuid',
                displayGrid: false,
                showIfDialog: (data) => data.kind === 'p2p'
            },
            {
                id: 'appealsDocuments',
                label: 'appealsDocuments',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                displayAdd: false,
                disableEditor: true,
                customData: true,
                disableSort: true
            },
            {
                id: 'appealsComments',
                label: 'appealsComments',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                displayAdd: false,
                disableEditor: true,
                customData: true,
                disableSort: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true,
                extraRender: (value, row) => getModifiedBy(row)
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];

        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head,

            currentAppealDocuments: [],
            currentAppealComments: [],
            appealsDocumentsOpen: false,
            appealsCommentsOpen: false,

            openDialogConfirm: false,
            appealId: null
        };
    }

    customLogicOnMount = async () => {
        const documentsRes = await this.fetchAppealDocuments();
        const commentsRes = await this.fetchAppealComments();
        this.appealsDocuments = documentsRes.data;
        this.appealsComments = commentsRes.data;
    };

    fetchAppealDocuments = async () => {
        return await this.props.context
            .getState()
            .server.publicAppealDocuments.getAll();
    };
    fetchAppealComments = async () => {
        return await this.props.context
            .getState()
            .server.publicAppealComments.getAll();
    };

    openAppealsDocuments = () => {
        const appealId = this.state.menuClickItemId;
        const currentAppealDocuments = this.appealsDocuments?.filter(
            (document) => document.appeal?.id === appealId
        );
        this.setState({
            appealsDocumentsOpen: true,
            currentAppealDocuments,
            appealId
        });
        this.handleCloseMenu();
    };

    openAppealsComments = () => {
        const appealId = this.state.menuClickItemId;
        const currentAppealComments = this.appealsComments?.filter(
            (comment) => comment.appeal?.id === appealId
        );
        this.setState({
            appealsCommentsOpen: true,
            currentAppealComments,
            appealId
        });
        this.handleCloseMenu();
    };

    closeAppealsDocuments = async () => {
        this.setState({ appealsDocumentsOpen: false, appealId: null });
    };

    closeAppealsComments = async () => {
        this.setState({ appealsCommentsOpen: false, appealId: null });
    };

    setAppealDocuments = async () => {
        const id = this.state.appealId;
        const res = await this.fetchAppealDocuments();
        this.appealsDocuments = res.data;
        const currentAppealDocuments = res.data.filter(
            (document) => document.appeal?.id === id
        );
        this.setState({
            currentAppealDocuments
        });
    };

    setAppealComments = async () => {
        const id = this.state.appealId;
        const res = await this.fetchAppealComments();
        this.appealsComments = res.data;
        const currentAppealComments = res.data.filter(
            (comment) => comment.appeal?.id === id
        );
        this.setState({ currentAppealComments });
    };

    handleUpdateStatus = async () => {
        const { status } = this.state;
        const id = this.state.appealId;

        await this.Server.updateStatus(id, status);
        this.handleCloseMenu();
        this.setState({ openDialogConfirm: false, status: '' });
        await this.retrieveData();
    };
    handleCancelStatusConfirm = () => {
        this.setState({ openDialogConfirm: false, status: '', appealId: null });
    };
    handleUpdateStatusConfirm = (status) => {
        const alertText = i18n.t(`common.${status}AlertText`);
        const alertTitle = i18n.t(`common.${status}AlertTitle`);

        const appealId = this.state.menuClickItemId;

        this.setState({
            openDialogConfirm: true,
            status,
            alertText,
            alertTitle,
            open: false,
            appealId
        });
        this.handleCloseMenu();
    };

    renderCustomMenuItems() {
        const currentAppealComments =
            this.appealsComments?.filter(
                (comment) => comment.appeal?.id === this.state.menuClickItemId
            ).length || 0;
        const currentAppealDocuments =
            this.appealsDocuments?.filter(
                (document) => document.appeal?.id === this.state.menuClickItemId
            ).length || 0;

        const appealId = this.state.menuClickItemId;
        const value = this.List.find((item) => item.id === appealId)?.status;
        const isAllowedChangeStatusAction = this.allowedAction(
            'appeal-approve-reject'
        ) && value && value === appealStatuses.pending;

        return [
            isAllowedChangeStatusAction && (
                <MenuItem
                    key="check"
                    onClick={() => this.handleUpdateStatusConfirm(appealStatuses.approved)}
                >
                    <Iconify icon={'ic:baseline-check'} sx={{ mr: 2 }} />
                    {i18n.t('buttons.approve')}
                </MenuItem>
            ),
            isAllowedChangeStatusAction && (
                <MenuItem
                    key="reject"
                    onClick={() => this.handleUpdateStatusConfirm(appealStatuses.rejected)}
                >
                    <Iconify icon={'eva:close-fill'} sx={{ mr: 2 }} />
                    {i18n.t('buttons.reject')}
                </MenuItem>
            ),
            <MenuItem
                key="appealsDocuments"
                onClick={() => this.openAppealsDocuments()}
            >
                <TextSnippetIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.appealDocuments')}
                <Chip sx={{ ml: 1 }} label={currentAppealDocuments} />
            </MenuItem>,
            <MenuItem
                key="appealsComments"
                onClick={() => this.openAppealsComments()}
            >
                <CommentIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.appealComments')}
                <Chip sx={{ ml: 1 }} label={currentAppealComments} />
            </MenuItem>,
        ];
    }

    renderCustom() {
        const appealId = this.state.appealId;

        return (
            <div>
                <DocumentsDialog
                    dialogOpen={this.state.appealsDocumentsOpen}
                    dialogData={this.state.currentAppealDocuments}
                    id={appealId}
                    type="appeal"
                    onCancel={() => this.closeAppealsDocuments()}
                    fetchData={() => this.setAppealDocuments()}
                    context={this.props.context}
                />
                <CommentsDialog
                    dialogOpen={this.state.appealsCommentsOpen}
                    dialogData={this.state.currentAppealComments}
                    id={appealId}
                    type="appeal"
                    controller="publicAppealComments"
                    onCancel={() => this.closeAppealsComments()}
                    fetchData={() => this.setAppealComments()}
                />
                <ConfirmDialog
                    dialogOpen={this.state.openDialogConfirm}
                    alertText={this.state.alertText}
                    alertTitle={this.state.alertTitle}
                    onCancel={this.handleCancelStatusConfirm}
                    onConfirm={this.handleUpdateStatus}
                />
            </div>
        );
    }

    renderCustomGridCell(Component, row, field) {
        const dates = {
            appealsDocuments: this.appealsDocuments,
            appealsComments: this.appealsComments
        };
        const data = dates[field.id] || [];

        const currentData = data.filter((item) => item.appeal?.id === row.id);
        const value = currentData ? currentData.length : 0;

        return (
            <Component
                key={field.label}
                id={row.id}
                value={value}
                field={field}
                row={row}
                handleChange={this.handleChangeCell}
            />
        );
    }
}
